/** mst_statuses: 1 = active, 2 = inactive (matches master table status_id). */
export function isActiveMasterRow(row) {
  if (!row) return false;
  if (Number(row.is_active) === 2) return false;
  const statusId = row.status_id != null ? Number(row.status_id) : 1;
  return statusId === 1;
}

export function filterActiveMasterRows(rows) {
  return (rows || []).filter(isActiveMasterRow);
}

/**
 * Build select options from master rows; include current selection when editing
 * a plan that still references an inactive master.
 */
export function masterSelectOptions(
  rows,
  { valueKey = "id", labelKey, selectedValue } = {},
) {
  const active = filterActiveMasterRows(rows);
  const options = active.map((row) => ({
    value: row[valueKey],
    label: row[labelKey],
  }));

  const selectedNum =
    selectedValue != null && selectedValue !== ""
      ? Number(selectedValue)
      : null;
  if (
    selectedNum != null &&
    !Number.isNaN(selectedNum) &&
    !active.some((r) => Number(r[valueKey]) === selectedNum)
  ) {
    const current = (rows || []).find((r) => Number(r[valueKey]) === selectedNum);
    if (current) {
      options.unshift({
        value: current[valueKey],
        label: `${current[labelKey]} (inactive)`,
      });
    }
  }

  return options;
}
